/* TODO A process overwrites variables named as environments */
// ['development', 'testing', 'staging', 'production']
const environments = {
    dev: 'dev',
    test: 'test',
    stag: 'stag',
    prod: 'prod'
};

const ENABLE_SIGN_ATTEMPTS = [environments.dev, environments.test].some(env => process.env.NODE_ENV.includes(env));

export default {
    enableSignAttempts: ENABLE_SIGN_ATTEMPTS,
};
